import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=ccd381c4&scoped=true&"
import script from "./Dates.vue?vue&type=script&lang=js&"
export * from "./Dates.vue?vue&type=script&lang=js&"
import style0 from "./Dates.vue?vue&type=style&index=0&id=ccd381c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd381c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VDatePicker,VFlex,VLayout,VProgressLinear})
